import styled from 'styled-components';
import googleLogo from '../images/google-logo.png';
import seznamLogo from '../images/seznam-logo.png';

export const SocialButton = styled.button`
	height: 40px;
	border-radius: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 5px;
	border: 1px solid #dadce0;
	background-color: #fff;
	transition: background-color 0.3s;
	cursor: pointer;
	margin-bottom: 10px;

	img {
		width: 20px;
		height: 20px;
	}
`;

interface Props {
	hideSeznam?: boolean;
	hideGoogle?: boolean;
	googleOnClick?: () => void;
	seznamOnClick?: () => void;
}

export const SocialButtons = ({ hideGoogle, hideSeznam, googleOnClick, seznamOnClick }: Props) => (
	<>
		{!hideSeznam && (
			<SocialButton type="button" onClick={seznamOnClick}>
				<img src={seznamLogo} alt="seznam" />
				<span>Přihlásit se přes Seznam</span>
			</SocialButton>
		)}
		{!hideGoogle && (
			<SocialButton type="button" onClick={googleOnClick}>
				<img src={googleLogo} alt="google" />
				<span>Přihlásit se přes Google</span>
			</SocialButton>
		)}
	</>
);
